import { all, fork } from 'redux-saga/effects'

import LocationService from './Location'
import LocalisationService from './Localisation'
import NavigationService from './Navigation'
import StoresService from './Stores'
import StatesService from './States'
import CMSService from './cms'

function* services() {
  yield all([
    fork(LocationService),
    fork(LocalisationService),
    fork(NavigationService),
    fork(StoresService),
    fork(StatesService),
    fork(CMSService),
  ])
}

export default services
